import { render, staticRenderFns } from "./ContractRenewals.vue?vue&type=template&id=d1a51c62&"
import script from "./ContractRenewals.vue?vue&type=script&lang=js&"
export * from "./ContractRenewals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports